// extracted by mini-css-extract-plugin
export default {"itemValue":"G68bf7e","itemRecipes":"Ge43939","itemSkip":"Gf4026a","itemDietary":"Gdf3dc8"};